import { Link } from 'react-router-dom';
import './Footer.css';

const SOCIAL_LINKS = [
  { label: 'Instagram', href: 'https://www.instagram.com/sistemas_administrativos/', icon: '/icons/desktop/Social link 1.svg' },
  { label: 'Facebook', href: null, icon: '/icons/desktop/Social link 2.svg' },
  { label: 'X', href: null, icon: '/icons/desktop/Social link 3.svg' },
  { label: 'WhatsApp', href: null, icon: '/icons/desktop/Vector.svg' },
];

const APPS_LINKS = [
  { label: 'ADA5WEB', href: 'http://www.ada5web.com.ar/', icon: '/images/desktop/home-product-ada5web.png' },
  { label: 'ADASUELDOS', href: 'http://adasueldos.com/SasaSueldos/Default.aspx?ReturnUrl=%2fSasaSueldos', icon: '/images/desktop/home-product-ada-sueldos.png' },
  { label: 'ConsorciosenRed', href: 'https://www.consorciosenredplus.com/', icon: '/images/desktop/home-product-cer.png' },
];

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__col site-footer__col--nav">
          <div className="site-footer__nav-row">
            <div className="site-footer__nav-group">
              <h3 className="site-footer__heading">¿Quiénes somos?</h3>
              <ul className="site-footer__apps">
                {APPS_LINKS.map((app) => (
                  <li key={app.label}>
                    <a href={app.href} target="_blank" rel="noopener noreferrer">
                      <img className="site-footer__app-icon" src={app.icon} alt="" />
                      {app.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="site-footer__nav-group">
              <h3 className="site-footer__heading">Conoce mas</h3>
              <ul>
                <li><Link to="/#contacto">Contacto</Link></li>
              </ul>
            </div>
          </div>
          <p className="site-footer__brand">Sistemas Administrativos S.A</p>
        </div>

        <div className="site-footer__col site-footer__col--contact">
          <ul className="site-footer__contact">
            <li>Teléfono: 0810-220-0078</li>
            <li>Mail: info@sisadm.com.ar</li>
            <li>Dirección: Rojas 1883, CABA</li>
          </ul>
          <div className="site-footer__social">
            {SOCIAL_LINKS.map((s) => (
              s.href ? (
                <a key={s.label} href={s.href} aria-label={s.label} target="_blank" rel="noopener noreferrer">
                  <img src={s.icon} alt="" />
                </a>
              ) : (
                <span key={s.label} className="site-footer__social-disabled" aria-label={s.label}>
                  <img src={s.icon} alt="" />
                </span>
              )
            ))}
          </div>
          <div className="site-footer__map">
            <iframe
              title="Mapa Rojas 1883, CABA"
              src="https://maps.google.com/maps?q=Rojas+1883,+CABA&t=&z=15&ie=UTF8&iwloc=&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <a
            className="site-footer__map-link"
            href="https://maps.google.com/?q=Rojas+1883+CABA"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver en Google Maps →
          </a>
        </div>
      </div>
    </footer>
  );
}
